module.exports = __webpack_public_path__ + "img/gaku_text_04.0162a79f.png";